/**
 * OpenQuestionsList Component
 * Displays open questions and unresolved items from project documents.
 */

import React from 'react';
import { HelpCircle } from 'lucide-react';
import type { OpenQuestion } from '@/services/projectAnalysisApi';
import { InsightCard } from './InsightCard';

interface OpenQuestionsListProps {
  questions: OpenQuestion[];
}

export const OpenQuestionsList: React.FC<OpenQuestionsListProps> = ({ questions }) => {
  if (questions.length === 0) {
    return (
      <div className="text-center py-8 text-slate-500">
        <HelpCircle className="w-12 h-12 mx-auto mb-3 text-slate-300" />
        <p>No open questions found in your documents.</p>
        <p className="text-sm mt-1">Questions and uncertainties will appear here.</p>
      </div>
    );
  }

  // Sort by priority (high first)
  const priorityOrder = { high: 0, medium: 1, low: 2 };
  const sorted = [...questions].sort(
    (a, b) => (priorityOrder[a.priority] ?? 2) - (priorityOrder[b.priority] ?? 2)
  );

  return (
    <div className="space-y-3">
      {sorted.map((question, index) => (
        <InsightCard
          key={index}
          type="question"
          title={question.question}
          description={question.context}
          source={question.source}
          priority={question.priority}
        />
      ))}
    </div>
  );
};

export default OpenQuestionsList;
